import React from 'react';

import './App.scss';
import { AuthContext } from './context/AuthContext';
import Loading from './utils/Loading';

const isLocalhost = window.location.hostname === 'localhost';
const loginUrl = isLocalhost ? 'http://localhost:3002/api-ui/auth/start' : '/api-ui/auth/start';

function checkIfValid({ setIsAuthed, setUserInfo, setLoading, opts }) {
	fetch('/api-ui/auth/user-info')
		.then((resp) => resp.json())
		.then((resp) => {
			if (!opts.isMounted) return;

			const data = {
				id: resp.id,
				email: resp.email,
				name: resp.name,
			};
			setUserInfo(data);

			if (data.email.endsWith('@eazygo.com.br')) {
				setIsAuthed(true);
				sessionStorage.setItem('hefestoAccessToken', resp.accessToken);
			} else {
				setIsAuthed(false);
			}
		})
		.catch((err) => {
			console.error(err);
			if (opts.isMounted) setIsAuthed(false);
		})
		.finally(() => {
			if (opts.isMounted) setLoading(false);
		});
}

export default function Login() {
	const { isAuthed, setIsAuthed, userInfo, setUserInfo } = React.useContext(AuthContext);
	const [loading, setLoading] = React.useState(true);

	React.useEffect(() => {
		const opts = { isMounted: true };
		if (!isAuthed) checkIfValid({ setIsAuthed, setUserInfo, setLoading, opts });
		return () => (opts.isMounted = false);
	}, [setIsAuthed, setUserInfo, isAuthed]);

	if (loading) {
		return <Loading />;
	}

	return (
		<center>
			<p>{userInfo.email}</p>
			<h3>Você não tem permissão para acessar essa página</h3>
			<a href={loginUrl} target={isLocalhost ? '_blank' : '_self'} rel="noreferrer">
				Fazer login
			</a>
		</center>
	);
}
